import { Link } from 'react-router';

import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';
import { useClinicians } from '../../hooks/clinicians';

import { ClinicianCard } from '../clinician-card';
import { LoadFailed } from '../load-failed';

import styles from './style.module.css';

// Your clinicians, in a patient's Settings (C22): each invitation waiting
// for an answer as a banner leading to it, then every clinician the patient
// is connected with.
export function YourClinicians() {
  const { text, language } = useLanguage();
  const { data, error, retry } = useClinicians();

  let content = null;

  if (error != null) {
    content = <LoadFailed onRetry={ retry }/>;
  }

  if (data !== undefined) {
    const banners = data.invitations.map(function({ id, sentAt, clinician }) {
      return (
        <div key={ id } className={ styles.banner }>
          <span className={ styles.lines }>
            <span className={ styles.kind }>{ text.invitation }</span>
            <span className={ styles.who }>{ text.wantsToConnect.replace('{name}', `${ clinician.firstName } ${ clinician.lastName }`) }</span>
            <span className={ styles.detail }>{ text.sentOn.replace('{date}', describe({ day: dayOf(sentAt), language, short: true })) }</span>
          </span>

          <Link className={ styles.review } to={ `/invitations/${ id }` }>{ text.reviewInvitation }</Link>
        </div>
      );
    });

    let cards = data.clinicians.map(function(clinician) {
      return <ClinicianCard key={ clinician.id } clinician={ clinician }/>;
    });

    if (cards.length === 0 && banners.length === 0) {
      cards = <p className={ styles.empty }>{ text.noClinicians }</p>;
    }

    content = (
      <>
        { banners }

        { cards }
      </>
    );
  }

  return (
    <section className={ styles.section } aria-labelledby='your-clinicians'>
      <h2 id='your-clinicians' className={ styles.heading }>{ text.yourClinicians }</h2>

      { content }
    </section>
  );
}
